import React, { useCallback, useState } from 'react';
import { Button } from 'react-bootstrap';
import DocumentCreate from './DocumentCreate';
import DocumentList from './DocumentList';
import DocumentDetail from './DocumentDetail';
import { useUser } from '../../context/UserContext';
import { useTenant } from '../../context/TenantContext';
import { useMembership } from '../../context/MembershipContext';
import {
  canCreateContentForTenant,
  isTenantAdminForTenant,
} from '../../platform/membershipPermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import useBrowserBackStack from '../../hooks/useBrowserBackStack';
import './Documents.css';

function Documents() {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showCreateDocument, setShowCreateDocument] = useState(false);
  const [documentToEdit, setDocumentToEdit] = useState(null);

  const { user } = useUser();
  const { tenantId } = useTenant();
  const { memberships } = useMembership();

  const handleSelectDocument = (documentItem) => {
    setSelectedDocument(documentItem);
    setShowCreateDocument(false);
    setDocumentToEdit(null);
  };

  const resetToList = useCallback(() => {
    setSelectedDocument(null);
    setShowCreateDocument(false);
    setDocumentToEdit(null);
  }, []);

  const onList = !selectedDocument && !showCreateDocument;
  const closeDetailView = useBrowserBackStack(!onList, resetToList);

  const toggleCreateDocumentForm = () => {
    if (showCreateDocument) {
      closeDetailView();
      return;
    }
    setShowCreateDocument(true);
    setSelectedDocument(null);
    setDocumentToEdit(null);
  };

  const handleDocumentCreated = () => {
    setShowCreateDocument(false);
    setSelectedDocument(null);
    setDocumentToEdit(null);
  };

  const handleEditDocument = (documentItem) => {
    setDocumentToEdit(documentItem);
    setShowCreateDocument(true);
    setSelectedDocument(null);
  };

  const headerTitle = selectedDocument?.title || documentToEdit?.title
    || (showCreateDocument ? 'Naloži dokument' : 'Dokumenti');

  return (
    <div className="platform-module-container documents-container">
        <ModulePageHeader
          eyebrow={!onList ? 'Dokumenti' : undefined}
          title={headerTitle}
          subtitle={onList ? 'Pravilniki, dokumenti in datoteke za člane.' : undefined}
          actions={(
            <>
              {!selectedDocument && canCreateContentForTenant(memberships, tenantId, user) && (
                <Button variant="primary" onClick={toggleCreateDocumentForm}>
                  {showCreateDocument ? 'Nazaj na dokumente' : 'Naloži dokument'}
                </Button>
              )}
              {selectedDocument && (
                <Button variant="primary" onClick={closeDetailView}>Nazaj na dokumente</Button>
              )}
            </>
          )}
        />
        {!selectedDocument ? (
          <>
            {showCreateDocument ? (
              <DocumentCreate
                onDocumentCreated={handleDocumentCreated}
                documentToEdit={documentToEdit}
              />
            ) : (
              <DocumentList
                onSelectDocument={handleSelectDocument}
                isAdmin={isTenantAdminForTenant(memberships, tenantId, user)}
                onEditDocument={handleEditDocument}
              />
            )}
          </>
        ) : (
          <DocumentDetail document={selectedDocument} />
        )}
    </div>
  );
}

export default Documents;
